import React from "react";
import { MoveUp, MoveDown } from "lucide-react";
import CarteiraHeader from "./CarteiraHeader";
import CarteiraDetalhes from "./CarteiraDetalhes";

const Carteira = ({
  carteira,
  openAcordeon,
  toggleListVisibility,
  imagens,
  handleImageUpload,
  setImagem,
  save,
  handleInputChange,
  isLoading,
  periodoDeRenovacao,
  handleClick,
  copyDados,
  url,
  copyToClipboard,
  toggleSave,
  handleSave,
  isAdmin,
  newArrayGestores,
}) => {
  return (
    <div
      className={`flex flex-col m-2 bg-[#aac5fc] shadow-lg rounded-lg transition-height duration-300  ${
        openAcordeon === carteira.id ? "row-span-2" : "max-h-72"
      }`}
      key={carteira.id}
    >
      <div className="flex items-center justify-between w-full h-full">
        <CarteiraHeader
          carteira={carteira}
          imagens={imagens}
          handleImageUpload={handleImageUpload}
          setImagem={setImagem}
          save={save}
          handleInputChange={handleInputChange}
          isLoading={isLoading}
          periodoDeRenovacao={periodoDeRenovacao}
          handleClick={handleClick}
          copyDados={copyDados}
          url={url}
        />
        <button
          className="w-[5%] h-[100%] border-none flex items-center justify-center bg-blue-700 font-league-gothic text-white rounded-lg cursor-pointer transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            toggleListVisibility(carteira.id);
          }}
        >
          {openAcordeon === carteira.id ? <MoveUp /> : <MoveDown />}
        </button>
      </div>
      {openAcordeon === carteira.id && (
        <CarteiraDetalhes
          carteira={carteira}
          handleInputChange={handleInputChange}
          isAdmin={isAdmin}
          newArrayGestores={newArrayGestores}
          save={save}
          copyToClipboard={copyToClipboard}
          toggleSave={toggleSave}
          handleSave={handleSave}
        />
      )}
    </div>
  );
};

export default Carteira;
